<!-- eslint-disable vue/no-unused-vars -->
<template>
	<div class="special-attention">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h3 class="mb-0">Special Attention Account (SAA)</h3>
			</b-card-header>
			<div v-if="tableData.length > 0" class="card-table">
				<el-table :data="tableData" show-summary :summary-method="getSummaries" style="width: 100%">
					<el-table-column prop="commitment_approved_date" label="Detected Status" min-width="130" width="auto">
						<template slot="header" slot-scope="scope">
							<span class="text-break">{{ scope.column.label }}</span>
						</template>
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.commitment_approved_date }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="commitment_loan_statue" label="Facility" min-width="180" width="auto">
						<template slot="header" slot-scope="scope">
							<span class="text-break">{{ scope.column.label }}</span>
						</template>
						<template slot-scope="scope">
							<p class="top-line">{{ _gHlp.getValue(scope.row,'commitment_loan_statue','-') }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="commitment_is_special_attention" label="Detected A/C No." min-width="150" width="auto">
						<template slot="header" slot-scope="scope">
							<span class="text-break">{{ scope.column.label }}</span>
						</template>
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.commitment_is_special_attention }}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No SAA recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'

export default {
	name: 'special-attention',
	props: ['special_attention'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			tableData: this.special_attention
		}
	},
	methods: {
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
			if (index === 1) {
				sums[index] = 'Total';
				return;
			} else if (index === 2) {
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
				}, 0);
				} else {
					sums[index] = 'N/A';
				}
			}
			});

			return sums;
		}
	}
}
</script>